import { render, staticRenderFns } from "./CardElementsViewSwitch.vue?vue&type=template&id=2245a870"
import script from "./CardElementsViewSwitch.vue?vue&type=script&lang=js"
export * from "./CardElementsViewSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports